import zipcodeApi from '~/clientApis/zipcodeApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { getStore } from '~/mobx/AppStore';

const getZipcode = async () => {
    const { zipcodeStore, regionStore } = getStore();
    zipcodeStore.setIsGettingZipcode(true);
    try {
        const found = await zipcodeApi.checkAssignedZipcode(regionStore.selectedRegionId);
        return found;
    } catch (error) {
        showMessageModal('error', 'Error checking zipcode assigned');
        throw error;
    } finally {
        zipcodeStore.setIsGettingZipcode(false);
    }
};

export default getZipcode;
